export * from './private.component';
export * from './private.routes';